import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'floatingButton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floatingButton.html',
  styleUrl: './floatingButton.css'
})
export class FloatingButtonComponent {

  @Input() icon: string = 'add'; 
  @Input() title: string = 'Click me';
  @Input() color: string = 'rgb(0 127 184)'; 

  @Output() btnClick = new EventEmitter<void>();

  onClick() {
    this.btnClick.emit();
  }
}
